<template>

    <body style="direction: rtl; text-align: right;">
        <Header pageTitle=" البروفايل" />
        <div class="container">
            <div class="row g-3">
                <!-- Main content START -->
                <div class="col-lg-6 vstack gap-3">
                    <!-- My profile START -->
                    <div class="card">
                        <!-- Cover image -->
                        <!-- <div class="h-200px rounded-top"
                            style="background-image:url(assets/images/bg/05.jpg); background-position: center; background-size: cover; background-repeat: no-repeat;">
                        </div> -->
                        <div class="h-100px rounded-top"
                            style="background-color: #296080; background-position: center; background-size: cover; background-repeat: no-repeat;">
                        </div>
                        <!-- Card body START -->
                        <div class="card-body py-0">
                            <div class="d-sm-flex align-items-start text-center text-sm-start">
                                <div>
                                    <!-- Avatar -->
                                    <div class="avatar avatar-xxl mt-n5 mb-3">
                                        <!-- <img class="avatar-img rounded-circle border border-white border-3"
                                            src="assets/images/avatar/07.jpg" alt=""> -->
                                        <img v-if="userData.users_image"
                                            class="avatar-img rounded-circle border border-white border-3"
                                            :src="userData.users_image ? `https://zadcodeonline.com//ahmad/etqan/backEnd/upload/profile/${userData.users_image}` : 'assets/images/avatar/default-avatar.jpg'"
                                            alt="صورة المستخدم" />
                                        <img v-else class="avatar-img rounded-circle border border-white border-3"
                                            src="/assets/person.png" alt="صورة افتراضية" />
                                    </div>
                                </div>
                                <div class="ms-sm-4 mt-sm-3">
                                    <!-- Info -->
                                    <p style="font-weight: bold;color: #296080;" class="mb-0">{{ userData.users_name }}
                                        <!-- <i class="bi bi-patch-check-fill text-success small"></i> -->
                                    </p>
                                    <p>
                                        <i class="bi bi-star-fill text-warning"></i>
                                        <i class="bi bi-star-fill text-warning"></i>
                                        <i class="bi bi-star-fill text-warning"></i>
                                        <i class="bi bi-star-half text-warning"></i>
                                        <i class="bi bi-star text-warning"></i>
                                    </p>
                                </div>
                                <!-- Button -->
                                <div class="d-flex mt-3 justify-content-center ms-sm-auto">
                                    <router-link class="btn btn-primary-soft me-2" v-if="userData.users_type == 0"
                                        :to="{ name: 'CompleteProfile', params: { id: userData.id } }" type="button">
                                        اكمال الملف الشخصي
                                    </router-link>
                                    <router-link class="btn btn-success-soft me-2" v-if="userData.users_type == 1"
                                        :to="{ name: 'UpgradeToFreelancer' }" type="button">
                                        ترقية إلى مستقل
                                    </router-link>
                                    <router-link class="btn btn-primary me-2" v-if="userData.users_type == 2"
                                        :to="{ name: 'MyWorks', params: { id: userData.id } }" style="color: white;"
                                        type="button">
                                        إدارة أعمالي
                                    </router-link>
                                    <router-link class="btn me-2" v-if="userData.users_type == 2" to="#"
                                        style="color: white;background-color: #296080;" type="button">
                                        ارسال رسالة
                                    </router-link>
                                </div>
                            </div>
                            <!-- List profile -->
                            <ul class="list-inline mb-0 text-center text-sm-start mt-3 mt-sm-0">
                                <li class="list-inline-item"><i class="bi bi-briefcase me-1"></i> مبرمج</li>
                                <li class="list-inline-item"><i class="bi bi-geo-alt me-1"></i> {{
                                    userData.users_current_country }}</li>
                                <li class="list-inline-item"><i class="bi bi-calendar2-plus me-1"></i> تاريخ الانضمام في
                                    نوفمبر 26,
                                    2019
                                </li>
                            </ul>
                        </div>
                        <!-- Card body END -->
                        <div class="card-footer mt-3 text-center pb-0">
                            <router-link to="/profile-myPosts" class="btn btn-success me-2" style="color: #fff;">
                                عرض منشوراتي
                            </router-link>
                        </div>
                    </div>
                    <!-- My profile END -->


                    <!-- الطلبات -->
                    <div class="card">
                        <div class="card-header text-center border-0 pb-0">
                            <p class="card-title mb-2 fw-bold" style="color: #296080;">طلباتي</p>
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="btn-group" role="group">
                                    <button type="button" class="btn btn-sm" :class="{ 'active': filterType === 'all' }"
                                        @click="filterType = 'all'">الكل</button>
                                    <button type="button" class="btn btn-sm" :class="{ 'active': filterType === 0 }"
                                        @click="filterType = 0">جديد</button>
                                    <button type="button" class="btn btn-sm" :class="{ 'active': filterType === 1 }"
                                        @click="filterType = 1">جاري </button>
                                    <button type="button" class="btn btn-sm" :class="{ 'active': filterType === 2 }"
                                        @click="filterType = 2">مكتمل</button>
                                    <button type="button" class="btn btn-sm" :class="{ 'active': filterType === 3 }"
                                        @click="filterType = 3">ملغى</button>
                                </div>
                            </div>
                        </div>

                        <div class="card-body">
                            <div v-for="order in filteredOrders" :key="order.orders_id" class="mb-4 request-item"
                                style="border-bottom: 1px solid #ddd;">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="d-flex flex-column flex-sm-row align-items-sm-center">
                                        <router-link  :to="'/order/' + order.orders_id"
                                            style="text-decoration: none; color: inherit;">
                                            <div @click.prevent="saveOrderData(order)">
                                                {{ order.orders_description }}
                                            </div>
                                        </router-link>

                                    </div>
                                    <div class="d-flex">
                                        <button class="btn btn-sm mb-0 me-2" :class="getStatusClass(order.orders_type)">
                                            {{ getStatusText(order.orders_type) }}
                                        </button>
                                    </div>
                                </div>

                                <div class="mt-2 d-flex align-items-center justify-content-between">
                                    <p class="mb-1 small">{{ order.orders_at_create }}</p>
                                    <p v-if="order.orders_type !== 0" class="mb-1 small"
                                        style="color: #296080; font-weight: bold;">
                                        {{ order.quotation_price ?? 0 }} $
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Main content END -->
            </div> <!-- Row END -->
        </div>
        <Footer />
    </body>
</template>


<script>
import Header from '../../components/header.vue'
import Footer from '../../components/footer.vue'
import axios from 'axios';

export default {
    name: "HelloWorld",
    components: {
        Header,
        Footer,
    },
    props: {
        msg: String,
    },
    data() {
        return {
            userData: {},
            loading: true,
            orders: [], // الطلبات القادمة من API
            filterType: 'all', // الفلتر الحالي
            usersid: localStorage.getItem("userId"), // قم بتغيير الـ ID حسب الحاجة
            usertype: 2
        };
    },
    mounted() {
        if (!localStorage.getItem("orders")) {
            localStorage.setItem("orders", JSON.stringify(this.orders));
        }
        this.fetchOrders();
        const userId = localStorage.getItem("userId");
        if (userId) {
            this.fetchUserData(userId);
        } else {
            console.error("User ID غير موجود في Local Storage.");
        }
        console.log(userId);
    },
    computed: {
        // تصفية الطلبات حسب الفلتر المختار
        filteredOrders() {
            if (this.filterType === 'all') return this.orders;
            return this.orders.filter(order => order.orders_type == this.filterType);
        }
    },
    methods: {
        saveOrderData(order) {
            console.log("تم النقر على الطلب:", order); // تأكد من ظهور البيانات في الـ Console
            if (order) {
                localStorage.setItem("selectedOrder", JSON.stringify(order));
                console.log("تم تخزين بيانات الطلب:", order);
                this.$router.push('/order/' + order.orders_id); // الانتقال يدويًا بعد حفظ البيانات

            } else {
                console.error("الطلب غير موجود!");
            }
        },
        async fetchOrders() {
            try {
                const response = await axios.post('https://zadcodeonline.com/ahmad/etqan/backEnd/orders/view_myorders.php',
                    {
                        usersid: this.usersid,
                        usertype: this.usertype
                    },
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );

                console.log("لرد:", response.data);
                if (response.data.status === "success") {
                    console.log("الطلبات:", response.data.data);
                    this.orders = response.data.data;
                }
            } catch (error) {
                console.error("خطأ في جلب الطلبات:", error);
            }
        },
        // تحديد النص المناسب لكل نوع طلب
        getStatusText(type) {
            switch (type) {
                case 3: return "ملغى";
                case 2: return "مكتمل";
                case 1: return "جاري ";
                case 0: return "جديد";
                default: return "غير معروف";
            }
        },
        // تحديد لون الزر حسب نوع الطلب
        getStatusClass(type) {
            switch (type) {
                case 3: return "btn-success";
                case 2: return "btn-primary";
                case 1: return "btn-warning";
                case 0: return "btn-secondary";
                default: return "btn-dark";
            }
        },
        async fetchUserData(userId) {
            try {
                const response = await axios.post(
                    'https://zadcodeonline.com/ahmad/etqan/backEnd/profiles/view.php',
                    { usersid: userId },
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );
                if (response.data.status === "success") {
                    this.userData = response.data.data;
                    console.log("بيانات المستخدم:", this.userData);
                    this.loading = false;
                } else {
                    console.error("فشل في جلب بيانات المستخدم:", response.data);
                }
            } catch (error) {
                console.error("خطأ أثناء جلب بيانات المستخدم:", error);
            }
        },
    },
};
</script>



<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.spinner {
    width: 50px;
    height: 50px;
    border: 5px solid #ccc;
    border-top: 5px solid #296080;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}




.card-header {
    padding: 0.25rem 0.25rem;
    margin-bottom: 0;
    background-color: #fff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.09);
}

.card[data-v-b966fbcc] {
    background-color: #faf9f8;
    border-radius: 30px;
    padding: 1px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.hstack {
    display: flex;
    flex-direction: column;
}

body {
    padding: 70px 0px 0 0px;
}

a {
    color: #296080;
}

.navbar-light .navbar-nav .nav-link {
    color: #ffffff;
}


.card-header {
    border-radius: 30px;
}

h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #296080;
}

.text-itkan {
    font-size: 25px;
    color: #ffffff;
}

.text-person {
    color: #296080;
}

.text-date {
    font-size: 10px;
    color: #2e2e2e;
}

.rounded-card {
    border-radius: 25px;
    overflow: hidden;
}

.carousel-item img {
    border-radius: 30px;
    height: 200px;
    object-fit: cover;
}

/* إضافة قواعد جديدة أو تعديل القواعد الموجودة */
.card {
    background-color: #f8f9fa;
    /* لون فضي */
    border-radius: 15px;
    /* حواف دائرية */
    padding: 15px;
    /* إضافة مسافة داخلية */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    /* إضافة ظل للكرت */
}


@media (max-width: 576px) {
    .carousel-item img {
        border-radius: 30px;
        height: 200px;
        object-fit: cover;
    }
}


@media (max-width: 768px) {
    .navbar-light .navbar-nav .nav-link[data-v-5e4cad4c] {
        color: #296080;
    }

    .navbar>.container,
    .navbar>.container-fluid,
    .navbar>.container-sm,
    .navbar>.container-md,
    .navbar>.container-lg,
    .navbar>.container-xl,
    .navbar>.container-xxl {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: inherit;
        flex-wrap: inherit;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        flex-direction: row-reverse;
    }
}
</style>